export default __webpack_public_path__ + "static/media/pencil.acba94ff.svg";